import {ResponseFilter} from 'com/gongxigames/math/core/client/ResponseFilter';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {WinTypeConfig} from '@gongxigames/framework/slot/modules/winpresentation/WinConfig';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Field} from 'com/gongxigames/math/core/game/message/Field';
import {Spin} from 'com/gongxigames/math/core/game/Spin';

export class WinTypeFilter implements ResponseFilter<Session> {
    protected _winType: string;
    protected _winTypeConfigs: WinTypeConfig[];

    constructor(winType: string, winTypeConfigs: WinTypeConfig[]) {
        this._winType = winType;
        this._winTypeConfigs = winTypeConfigs;
    }

    public filter(response: Message, session: Session): boolean {
        const action = response.getAction();

        if (action === Action.SPIN || action === Action.FREESPIN || action === Action.RESPIN
            // @ts-ignore TODO: refactoring required!
            || action === Action.MINISPIN || action === Action.BUY_FEATURE) {
            const spinData = response.getField(Field.SPIN) as Spin;

            if (this._winType === 'noWin' && !spinData.pays.length) {
                return true;
            }

            const bet = spinData.totalBet.wager;
            const maxWinToBetRatio = this.getMaxWinToBetRatio();
            const minWinToBetRatio = this.getMinWinToBetRatio();
            let win = 0;

            for (const pay of response.getField<Spin>(Field.SPIN).pays) {
                win += pay.win;
            }

            const ratio = win / bet;

            return !!win && ratio >= minWinToBetRatio && ratio < maxWinToBetRatio;
        } else {
            return true;
        }
    }

    protected getMinWinToBetRatio(): number {
        return this._winTypeConfigs.find(type => type.name === this._winType)!.minWinToBetRatio;
    }

    protected getMaxWinToBetRatio(): number {
        for (let i = 0; i < this._winTypeConfigs.length; i++) {
            if (this._winTypeConfigs[i].name === this._winType) {
                return (i === 0) ? 1000000 : this._winTypeConfigs[i - 1].minWinToBetRatio;
            }
        }

        throw new Error();
    }

    public get name(): string {
        return this._winType;
    }
}
